/**
 * IPS 객체 설정 > 공통 Store
 *
 * @since 2021-08-04
 * @author jfko
 * @developer wj_tams_dev01
 */

import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
import {i18n} from '~/plugins/i18n'

// TAMS
import {
  // objectSetDataParser,
  parseAddrObjectTypeNumber,
  parseAddrObjectIpVersionType
} from 'objectSettingsUtils'

// NGF/IPS 와 같이 사용 가능???
const getIpsObjectTypeInfo = (objectType) => {
  let
    addrType = void 0,
    version = void 0

  if (objectType === 'service') {
    addrType = 'service'
  // } else if (objectType === 'serviceGroup') {
  //   addrType = 'service-group'
  } else
  if (objectType.indexOf('address.host') >= 0 || objectType.indexOf('address.group') >= 0 || objectType.indexOf('address.network') >= 0 || objectType.indexOf('address.domain') >= 0) {
    addrType = objectType.split('.')[1]
    if (/\.4/.test(objectType) || addrType === 'domain') {
      version = '4'
    } else if (/\.6/.test(objectType)) {
      version = '6'
    }
  }
  return {addrType, version}
}
// NGF/IPS 와 같이 사용 가능???
const getFormPcDownloadOfColumns = (objectType) => {
  let obj = {}
  if (objectType === 'service') {
    obj = {
      name: i18n.t('op.objectSettings_label_serviceName'),
      prtc: i18n.t('cmn.protocol'),
      srv_cate: i18n.t('op.objectSettings_field_serviceType'),
      start_port: i18n.t('cmn.sourcePort'),
      srv_port: i18n.t('cmn.servicePort'),
      life_time: 'Lifetime',
      prio: i18n.t('cmn.priority'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (objectType === 'serviceGroup') {
    obj = {
      name: i18n.t('op.objectSettings_label_serviceGroupName'),
      desc: i18n.t('cmn.description'),
      srv_name: i18n.t('op.objectSettings_label_serviceName'),
      prtc: i18n.t('cmn.protocol'),
      srv_type: i18n.t('op.objectSettings_field_serviceType'),
      source_port: i18n.t('cmn.sourcePort'),
      service_port: i18n.t('cmn.servicePort'),
      Lifetime: 'Lifetime',
      priority: i18n.t('cmn.priority'),
      obj_desc: i18n.t('cmn.objDesciption'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.host/.test(objectType)) {
    obj = {
      name: i18n.t('cmn.hostName'),
      ip_list: i18n.t('cmn.ipAddr'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.network/.test(objectType)) {
    obj = {
      name: i18n.t('cmn.networkName'),
      ip_list: i18n.t('cmn.ipAddr'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.group/.test(objectType)) {
    obj = {
      name: i18n.t('cmn.groupName'),
      // mmbr_obj: i18n.t('op.objectSettings_label_groupInObject'),
      desc: i18n.t('cmn.description'),
      object_type: i18n.t('cmn.objectType'), // 객체 타입
      object_name: i18n.t('cmn.objectName'), // 객체 명
      ip: i18n.t('cmn.ip'), // IP
      obj_desc: i18n.t('cmn.objDesciption'), // 객체 설명
      ref: i18n.t('cmn.usedCheck')
    }
  }
  const keys = Object.keys(obj)
  const result = []
  for (let i = 0, l = keys.length; i < l; i++) {
    result.push(obj[keys[i]])
  }
  return result.length === 0 ? '' : `columns=(${result.join(',')})`
}

// utils
import {ipsObjectList} from 'objectList' // ~/pages/cm/objectSecProfile/object/objectSettings/objectList
import {pcDownloadFile} from '~/utils/files'

function getCompData () {
  return {
    idp_ref: false, // 침입탐지 프로파일
    // idc_ref: false, // 침입탐지 공통 정책
    pd_ref: false,
    obj_type: ''
  }
}

export const state = () => ({
  cmApi: cmApiPrefix,
  objectList: [],
  selectTarget: void 0,
  objectUsedPopUpComp: {
    objectData: void 0,
    component: void 0,
    // TAMS
    detailData: [],
    compData: getCompData()
  },
  objectType: '',
  groupType: '',
  searchCase: false,
  searchText: '',
  searchType: ['name'],
  selectedData: [],
  usedTarget: {},
  multipleSelect: false
})

export const mutations = {
  setSelectedData (state, data) {
    state.selectedData = data
  },
  setUsedTarget (state, data) {
    state.usedTarget = data
  },
  // 객체 목록 초기화
  resetObjectList (state) {
    state.objectList = Object.freeze(_.cloneDeep(ipsObjectList(i18n)))
  },

  // 객체 목록 설정
  setObjectList (state) {
    state.objectList = Object.freeze(_.cloneDeep(ipsObjectList(i18n)))
  },

  // 선택된 객체 형태(ipMapping, user .. 사용)
  setSelectTarget (state, data) {
    state.selectTarget = data
  },

  // 객체 상세 검색 조건 설정
  setObjectSearch (state, {keyword, searchType, lowerCase}) {
    state.searchText = keyword
    state.searchType = searchType
    state.searchCase = lowerCase
  },

  // 객체 상세 검색 조건 초기화
  resetObjectSearch (state) {
    state.searchText = ''
    state.searchType = ['name']
    state.searchCase = false
  },

  // 객체 설정의 모든 데이터 리스트 state 초기화
  resetAllObjectDataList (state, rootState) {
    const store = rootState.cm.objectSecProfile.object.ipsObjectSettings

    store.groupObject.groupDataList = []
    store.serviceObject.serviceObjectDataList = []
    store.addressObject.addressObjectDataList = []
  },

  // 객체 사용 여부 팝업 컴포넌트 전역 설정
  setObjectUsedPopUpComp (state, data) {
    state.objectUsedPopUpComp.component = data
  },

  // 객체 형태 설정
  setObjectType (state, data) {
    state.objectType = data
  },

  // 그룹 형태 설정
  setGroupType (state, data) {
    state.groupType = data
  },

  // 객체 Counting
  getObjectViewCnt (state, {objectType, length}) {
    const objectList = _.map(state.objectList, (obj) => {
      if (obj.key === 'address') {
        const setData = (child, dataLength) => {
          _.each(child, (o) => {
            if (o.key === objectType) {
              _.assign(o, {
                dataLength: dataLength,
                header: 'custom'
              })
            }

            if (_.has(o, 'children')) {
              setData(o.children, length)
            }
          })
        }

        if (_.has(obj, 'children')) {
          setData(obj.children, length)
        }

        return obj
      } else {
        if (obj.key === objectType) {
          obj = {
            ...obj,
            dataLength: length
          }
        }

        return obj
      }
    })

    state.objectList = Object.freeze(objectList)
  },

  // 객체 Counting 속성 삭제
  removeObjectViewCnt (state) {
    const objectList = _.map(state.objectList, (obj) => {
      if (obj.key === 'address') {
        const setData = (child) => {
          _.each(child, (o) => {
            delete o.dataLength

            if (_.has(o, 'children')) {
              setData(o.children)
            }
          })
        }

        if (_.has(obj, 'children')) {
          delete obj.dataLength

          setData(obj.children)
        }

        return obj
      } else {
        delete obj.dataLength

        return obj
      }
    })

    state.objectList = Object.freeze(objectList)
  },

  // 다중 선택 여부 설정
  setMultipleSelect (state, data) {
    state.multipleSelect = data
  },

  // TAMS
  // 객체 설정의 모든 선택된 데이터 state 초기화
  resetAllSelectedData (state, rootState) {
    const store = rootState.cm.objectSecProfile.object.ipsObjectSettings

    store.groupObject.selectedData = void 0
    store.serviceObject.selectedData = void 0
    store.addressObject.selectedData = void 0
  },
  resetSelectedData (state) {
    state.selectedData = []
  }
}

export const actions = {
  // 객체 설정의 모든 데이터 리스트 state 초기화
  resetAllObjectDataList ({commit, rootState}) {
    commit('resetAllObjectDataList', rootState)
  },

  // 객체 Counting
  // isNotSelectedPrevent: 선택되지 않은 객체를 갱신을 못하도록 막는 옵션
  getObjectViewCnt ({commit, rootState, state}, {dataLength = 0, objectType, isNotSelectedPrevent = false}) {
    objectType = objectType || rootState.cm.objectSecProfile.object.ipsObjectSettings.common.objectType
    if (state.objectType !== objectType && isNotSelectedPrevent) {
      return
    }
    const length = dataLength

    // 객체 별 데이터 개수 설정
    commit('getObjectViewCnt', {objectType, length})
  },

  // // 객체 일괄 배치 처리대상의 파일 업로드 index.js 로 옮김...
  // async batchUpload ({commit, state}, {formData}) {
  //   let uri = `${cmnApiPrefix}/file/import`
  //   const {code, result} = await this.$axios.$post(uri, formData, {isNotAlert: true})
  //
  //   if (code === 'ok') {
  //     return result
  //   }
  // },

  // 업로드 결과 값으로 객체 일괄 배치 처리
  // async executeBatch ({commit, state, rootState, dispatch}, {file, allow_dup = false, isUrl = false}) {
  async executeBatch ({commit, state, rootState, dispatch}, {file, allow_dup = false}) {
    const objectType = state.objectType
    let {addrType, version} = getIpsObjectTypeInfo(objectType)

    let uri = `${objApiPrefix}/${addrType}`

    if (version) {
      uri += `/${version}`
    }

    uri += '/objects/ips/batch'
    const {code, result} = await this.$axios.$post(uri, {file, allow_dup})

    return {code, result}
  },

  // PC로 파일 다운로드
  async pcDownload ({commit, state}, {objectType}) {
    let {addrType, version} = getIpsObjectTypeInfo(objectType)

    let uri = `${objApiPrefix}/${addrType}`

    if (version) {
      uri += `/${version}`
    }

    uri += '/objects/ips/save'

    const columns = getFormPcDownloadOfColumns(objectType)
    if (columns) {
      uri += `?${columns}`
    }

    const {data, fileName} = await this.$axios.$file(uri, {responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },

  // IPS PC로 파일 다운로드
  async ipsPcSave ({commit, state}, {objectType}) {
    const {addrType, version} = getIpsObjectTypeInfo(objectType)
    const type = parseAddrObjectTypeNumber(addrType)
    const ipv = parseAddrObjectIpVersionType(version, addrType)
    const uri = `${cmApiPrefix}/objects/ips/addr${_.isEqual(addrType, 'group') ? '-grp' : ''}/excel?addr_obj_ip_ver_type=${ipv}&addr_obj_type_list=[${type}]`

    const {data, fileName} = await this.$axios.$file(uri, {responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },

  // TAMS
  // 객체 설정의 모든 선택된 리스트 초기화
  resetAllSelectedData ({commit, rootState}) {
    commit('resetAllSelectedData', rootState)
  }
}

export const getters = {
  /**
   * 합칠 수 있을까???
   * IPS 객체 목록 추가
   * - list, tree 형태 분리
   */
  objectList (state) {
    const objectList = []
    const objectTreeList = []

    _.find(state.objectList, (obj) => {
      // obj = generateObjectByFeature(rootState, obj) // TAMS 제외
      if (obj) {
        if (!obj.children) {
          objectList.push(obj)
        } else {
          objectTreeList.push(obj)
        }
      }
    })

    return {
      list: objectList,
      treeNode: objectTreeList
    }
  },

  // 객체 별 데이터 총 개수 조회
  totalDataCount (state, getters, rootState) {
    const objectType = state.objectType

    if (objectType === 'service') {
      const serviceObjectDataList = rootState.cm.objectSecProfile.object.ipsObjectSettings.serviceObject.serviceObjectDataList
      return serviceObjectDataList.length
    } else if (objectType && objectType.indexOf('address') > -1) {
      const addressObjectDataList = rootState.cm.objectSecProfile.object.ipsObjectSettings.addressObject.addressObjectDataList
      return addressObjectDataList.length
    } else {
      return 0
    }
  }
}

export const strict = false
